module.exports = __webpack_public_path__ + "static/media/sandik_2.f33f4077.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/sandik_2.jpeg
// module id = 309
// module chunks = 0